import { MARKS } from '@contentful/rich-text-types';
import { Options } from '@contentful/rich-text-react-renderer';
import ImgLoader from '~/components/Generic/ImgLoader';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { Grid } from '@theme-ui/components';

type Props = {
  chart: Queries.ProductAvailabilityChartFragment;
};

const ProductAvailabilityCard = ({ chart }: Props) => {
  return (
    <Grid
      sx={{
        border: '1px solid',
        borderColor: 'UIGray1',
        gap: 0,
        overflow: 'hidden',
      }}
    >
      <ImgLoader image={chart.image} alt={chart.title} forwardSx={{ my: '-2px', mx: '-2px' }} />
      <div
        sx={{
          background: 'black',
          color: 'white',
          p: '.8rem',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <h4 sx={{ textTransform: 'uppercase', fontSize: '1.6rem', fontWeight: 500, lineHeight: 1.2, m: 0 }}>
          {chart.tableHeader}
        </h4>
      </div>
      <div
        sx={{
          fontSize: '1.3rem',
          px: '1.6rem',
          py: '.6rem',
          table: {
            width: '100%',

            borderCollapse: 'collapse',
            td: {
              pr: ['1rem', '2rem'],
              pl: 0,
              py: '.8rem',
            },
            'tr:not(:last-of-type) > td': {
              borderBottom: '1px solid',
              borderColor: 'UIGray5',
            },
            'tr:not(:last-of-type) > td:first-of-type': {
              borderColor: 'transparent',
            },
            'td:first-of-type': {
              textAlign: 'right',
            },
            'tr:nth-of-type(even):not(:last-of-type)': {
              borderBottom: '2px solid',
              borderColor: 'UIGray1',
            },
          },
          p: {
            m: 0,
          },
        }}
      >
        {/* @ts-expect-error - this library expects references, but we don't have any */}
        {chart.table && renderRichText(chart.table, options)}
      </div>
    </Grid>
  );
};

export default ProductAvailabilityCard;

const options = {
  renderMark: {
    [MARKS.BOLD]: (text) => <strong sx={{ fontWeight: 'medium' }}>{text}</strong>,
    [MARKS.ITALIC]: (text) => <em sx={{ fontStyle: 'italic' }}>{text}</em>,
    [MARKS.UNDERLINE]: (text) => <span sx={{ textDecoration: 'underline' }}>{text}</span>,
  },
} satisfies Options;
